import graphql from "babel-plugin-relay/macro";

const HomePageQuery = graphql`

    query HomePageQuery($product_IsBestseller: Boolean,$slug: String! ) {
		category : category {
            edges {
                node {
                 id
                 name    
                 backgroundImage  
                 categoryIcon    
                }
            }
		}
        productVariants:productVariants(product_IsBestseller:$product_IsBestseller) {
            edges {
                node {
                    id
                    sku
                    variantId
                    isAvailable
                    price
                    getPrice
                    getOriginalPrice
                    featuredImage
                    discountedPrice
                    discountPercentage
                    isInWishlist
                    product {
                        id
                        name
                        rating
                        description
                        price
                        weight
                        discountedPrice
                        masterSku
                        featuredImage
                       
                        featuredImage
                        collection{
                            id
                            name
                        }
        
                    }
                }
            }
        }
        collections:collections {
            id
            name
            image
            desktopBanner
            mobileBanner
		}
        allTestimonials:allTestimonials {
            edges {
                node {
                    id
                    name
                    testimonial
                }
            }
        }
        getCatalogueBySlug:getCatalogueBySlug(slug: $slug) {
		    id
		    name
		    slug
		    file
		
		}
	}
`

export default HomePageQuery
